import { render, staticRenderFns } from "./Builder.vue?vue&type=template&id=4a1b5650"
import script from "./Builder.vue?vue&type=script&lang=js"
export * from "./Builder.vue?vue&type=script&lang=js"
import style0 from "./Builder.vue?vue&type=style&index=0&id=4a1b5650&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports